/**
 * TimelineGroupHeader Component
 *
 * Collapsible group header banner for grouped crops (species/location/family).
 * Click to expand/collapse all crops in the group.
 */

import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { GROUP_HEADER_HEIGHT, Y_AXIS_TYPOGRAPHY_PAD_R } from '../../timeline-constants'

/**
 * TimelineGroupHeader - Collapsible group banner
 *
 * @param {Object} props
 * @param {Object} props.group - Group object { groupId, groupName, crops }
 * @param {boolean} props.isExpanded - Group expansion state
 * @param {Function} props.onToggle - Toggle handler
 */
export const TimelineGroupHeader = ({ group, isExpanded, onToggle }) => {
  const theme = useTheme()

  return (
    <Box
      onClick={onToggle}
      sx={{
        pl: '0.5rem',
        height: GROUP_HEADER_HEIGHT,
        bgcolor: theme.palette.primary.light,
        borderBottom: `1px solid ${theme.palette.divider}`,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'auto',
        '&:hover': {
          bgcolor: theme.palette.primary.main,
        }
      }}
    >
      <Icons.ExpandMore
        sx={{
          fontSize: 16,
          mr: 0.5,
          transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
          transition: 'transform 0.2s'
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: 'white',
          pr: Y_AXIS_TYPOGRAPHY_PAD_R
        }}
      >
        {group.groupName} ({group.crops.length})
      </Typography>
    </Box>
  )
}
